import React from 'react'
import { Button } from 'shared/ui'
import styles from './styles.module.scss'

type ISwitchModeProps = {
  toggle: boolean
  isMMS: boolean
  isRCS: boolean
  onChange: () => void
}

export const SwitchMode: React.FC<ISwitchModeProps> = ({ toggle, isMMS, isRCS, onChange }) => {
  const mode = isRCS ? 'RCS' : isMMS ? 'MMS' : 'SMS'
  return (
    <div className={styles.wrap}>
      <Button
        typeBtn={'contained'}
        contained={'secondary'}
        intent={toggle ? 'warning' : 'default'}
        size={'small'}
        iconProps={{
          icon: toggle ? 'edit' : 'messageSmile',
          fontSize: 12,
        }}
        text={toggle ? 'Note' : mode}
        onClick={() => {
          onChange()
        }}
        disableHover
        tabIndex={-1}
      />
    </div>
  )
}
